export default __webpack_public_path__ + "static/media/recruit_optimizer_pic.e0b8b43f.png";